export default __webpack_public_path__ + "static/media/4.529403a5.png";